import PropTypes from 'prop-types';
import React from 'react';
import css from './MultiColStepCard.css';
import StepCard from './StepCard';

const MultiColStepCard = ({ items, columnsCount = 2, ...props }) => {
    const itemsPerColumnCount = Math.ceil(items.length / columnsCount);
    const columns = Array.from({ length: columnsCount }, (_, columnIndex) => {
        const start = columnIndex * itemsPerColumnCount;
        const end = start + itemsPerColumnCount;
        return items.slice(start, end);
    });

    const renderColumn = columnItems => (
        <div className={css.column}>
            {columnItems.map(({ title, children }) => (
                <div key={title} className={css.item}>
                    <span className={css.title}>{title}</span>
                    {children}
                </div>
            ))}
        </div>
    );

    return (
        <StepCard {...props} className={css.stepCard}>
            <div className={css.content}>{columns.map(renderColumn)}</div>
        </StepCard>
    );
};

MultiColStepCard.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            children: PropTypes.arrayOf(PropTypes.node).isRequired,
        })
    ).isRequired,
    columnsCount: PropTypes.number,
};

export default MultiColStepCard;
